import { Icon } from "../../icons";
import { BuzerIcon } from "../../BuzerIcons";
import { st } from "../../styles.js";
import { Button, IconButton } from "./ds";

// App wordmark — icon + "Buzerlístok".
export function Brand({ size = 20 }) {
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 7 }}>
      <BuzerIcon name="flame" size={Math.round(size * 1.15)} color="var(--text)" />
      <span style={{ fontFamily: "var(--font-display)", fontWeight: 700,
        fontSize: size, color: "var(--text)", letterSpacing: "-0.3px" }}>Buzerlístok</span>
    </span>
  );
}

// PRO upsell card shown where a free user hits a paywall.
export function ProUpsell({ title, lines }) {
  return (
    <div style={{ ...st.card, textAlign: "center", alignItems: "center" }}>
      <div style={{ fontSize: 34 }}>🔒</div>
      <div style={{ fontSize: 18, fontWeight: 700 }}>{title} je súčasťou Community</div>
      <div style={st.taskDesc}>{lines || "Odomkni neobmedzené návyky, spoločné výzvy, priateľov, chat, zdieľané kalendáre a kategórie úloh."}</div>
      <div style={{ fontSize: 14, fontWeight: 700, color: "var(--price-accent)" }}>Už od 3,50 € / mesiac — menej ako cappuccino v Bratislave ☕</div>
      <a href="/o-aplikacii#cennik" style={{ ...st.primaryBtn, textDecoration: "none", display: "block" }}>Zobraziť Community ›</a>
    </div>
  );
}

// A dashed "add" button that's locked behind PRO (links to the pricing section).
export function ProButton({ label }) {
  return (
    <a href="/o-aplikacii#cennik"
      style={{ ...st.addToggle, display: "block", textAlign: "center", textDecoration: "none" }}>
      🔒 {label} — len v Community
    </a>
  );
}

// Inline check glyph used in lists/labels.
export const Chk = ({ size = 13, color = "currentColor" }) => (
  <Icon name="check" size={size} color={color} stroke={3} style={{ verticalAlign: "-2px", marginRight: 3 }} />
);

// Dismissable info/hint banner with an optional action.
// `onOpen` spraví z ikony+textu (nie z celého banneru — ✕ musí ostať samostatné) tlačidlo,
// ktoré otvorí súvisiaci detail. Používa to Tip dňa: ťuk otvorí zoznam všetkých tipov.
export function HintBanner({ icon, title, desc, descClassName, actionLabel, onAction, actionBusy, onDismiss, dismissTitle, onOpen, openTitle, ...rest }) {
  const body = (<>
    {/* bordered icon chip; icon can be a BuzerIcon name (string) or a node */}
    <span className="bz-hint__icon">{typeof icon === "string" ? <BuzerIcon name={icon} size={19} color="currentColor" /> : icon}</span>
    <span className="bz-hint__body">
      {/* nadpis = .bz-row__title; popis = bz-aitext PRE VŠETKY bannery (jednotné), ak sa neurči inak */}
      <span className="bz-row__title" style={{ display: "block" }}>{title}</span>
      <span className={descClassName || "bz-aitext"}>{desc}</span>
    </span>
  </>);
  return (
    /* ...rest prepúšťa data-* atribúty (napr. data-backfill-hint na doscrollovanie) —
       bez neho by sa banner nedal zvonku nájsť ani zamerať */
    <div className="bz-hint" {...rest}>
      <div className="bz-hint__row">
        {onOpen
          ? <button type="button" className="bz-hint__open" onClick={onOpen} title={openTitle} aria-label={openTitle}>{body}</button>
          : body}
        {actionLabel && <Button variant="secondary" size="sm" onClick={onAction} disabled={actionBusy} style={{ flexShrink: 0 }}>{actionBusy ? "…" : actionLabel}</Button>}
        {onDismiss && <IconButton variant="ghost" size="sm" onClick={onDismiss} title={dismissTitle || "Skryť"} aria-label={dismissTitle || "Skryť"} style={{ flexShrink: 0 }}><Icon name="close" size={16} color="currentColor" /></IconButton>}
      </div>
    </div>
  );
}
